// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { rfqConfirmationReturnToCartStyles } from "@conklin/App/Widgets/QuoteConfirmation/RfqConfirmationReturnToCart";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqConfirmationReturnToCartStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: ${color("common.ui2")};
        border: 1px solid ${color("common.border")};
        height: 52px;
        padding: 12px;
        margin-top: 24px;

        &:empty {
            display: none;
        }

        ${xScreen("lte", "md")} {
            height: auto;
            flex-direction: column;
            gap: 24px;
            align-items: start;
        }
    `,
};

rfqConfirmationReturnToCartStyles.returnToCartText = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

rfqConfirmationReturnToCartStyles.returnToCartButton = {
    css: css`
        min-height: 28px;
        max-width: 145px;
        span {
            font-size: 11px;
            white-space: nowrap;
        }
    `,
};
